export const INITIAL_STATE = {
  cdes: null,
  selectedCde: null,
  pivotedTable: {
    headings: null,
    count: 0,
    rows: null,
    isLoading: false,
  },
  aggregatedTable: {
    headings: null,
    rows: null,
    isLoading: false,
  },
  isPivotedDataSectionLoading: false,
  pagination: {
    currentPage: 1,
    pageSize: 20,
  },
  npiSearch: "",
};

export const ACTIONS = {
  SET_CDES: "SET_CDES",
  SET_SELECTED_CDES: "SET_SELECTED_CDES",
  SET_PIVOTED_TABLE: "SET_PIVOTED_TABLE",
  SET_AGGREGATED_TABLE: "SET_AGGREGATED_TABLE",
  SET_PAGINATION: "SET_PAGINATION",
  SET_PIVOTED_DATA_SECTION_LOADING: "SET_PIVOTED_DATA_SECTION_LOADING",
  SET_NPI_SEARCH: "SET_NPI_SEARCH",
};

export const multiSourceDashboardReducer = (state, { type, payload }) => {
  switch (type) {
    case ACTIONS.SET_CDES:
      return { ...state, cdes: payload };

    case ACTIONS.SET_SELECTED_CDES:
      return { ...state, selectedCde: payload };

    case ACTIONS.SET_PIVOTED_TABLE:
      return { ...state, pivotedTable: { ...state.pivotedTable, ...payload } };

    case ACTIONS.SET_AGGREGATED_TABLE:
      return {
        ...state,
        aggregatedTable: { ...state.aggregatedTable, ...payload },
      };

    case ACTIONS.SET_PAGINATION:
      return {
        ...state,
        pagination: { ...state.pagination, ...payload },
      };

    case ACTIONS.SET_PIVOTED_DATA_SECTION_LOADING:
      return { ...state, isPivotedDataSectionLoading: payload };

    case ACTIONS.SET_NPI_SEARCH:
      return { ...state, npiSearch: payload };

    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
};
